<template>
    <transition name="show-tool">
        <div class="nav-bar t-line">
            <!-- <progressBar/> -->
            <div class="nav-item">
                <a @click="topage('/index')" :class="$route.path=='/index' ? 'on' : ''">
                    <p><i class="iconfont icon-shouye1"></i></p>
                    <p>首页</p>
                </a>
            </div>
            <div class="nav-item">
                <a @click="topage('/extension')" :class="$route.path=='/extension' ? 'on' : ''">
                    <p><i class="iconfont icon-shouyiicon"></i></p>
                    <p>推广</p>
                </a>
            </div>
            <div class="nav-item">
                <a @click="topage('/order')" :class="$route.path=='/order' ? 'on' : ''">
                    <p><i class="iconfont icon-woxiangyaodegongnengicon"></i></p>
                    <p>订单</p>
                </a>
            </div>
            <div class="nav-item">
                <a @click="topage('/user')" :class="$route.path=='/user' ? 'on' : ''">
                    <p><i class="iconfont icon-zhanghu1"></i></p>
                    <p>我的</p>
                </a>
            </div>
        </div>
    </transition>
</template>
<script>
// import progressBar from './progressBar.vue'
export default {
    // components: {
    //     progressBar
    // }
    mounted () {
        console.log(this.$route.path)
    },
    methods: {
        topage (path) {
            this.$router.replace(path)
        }
    }
}
</script>

<style lang="less">
.nav-bar {
    display: flex;
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    height: 52px;
    width: 100%;
    background: #fff;
    &.t-line::before {
        border-color: #03bdf4;
    }
    .nav-item {
        flex: 1;
        text-align: center;
        font-size: 12px;
        a {
            display: block;
            width: 60px;
            margin: auto;
            padding: 7px 0;
            color: #999;
        }
        .on {
            color: #03bdf4;
            text-shadow: 0 0 3px #03bdf48a;
        }
        .iconfont {
            font-size: 20px;
            width: 20px;
            height: 20px;
        }
    }
}
.show-tool-leave-active {
    animation-duration: 400ms;
    animation-name: bottomOut;
}
.show-tool-enter-active {
    animation-duration: 400ms;
    animation-name: bottomIn;
}
@keyframes bottomIn {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}
@keyframes bottomOut {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(100%);
    }
}
</style>
